import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=440fe85c&"
import script from "./LoadingAnimation.vue?vue&type=script&lang=ts&"
export * from "./LoadingAnimation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports